import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

import Navbar from './Navbar';
import { Container, ListGroup, Row } from "react-bootstrap";

import './css/Purpose.css';

function Purpose() {
    return (

        <div className="grid gap-0 row-gap-3">

            <div className="p-5">
                <Navbar />
            </div>

            <div className="ml-5">
                <Container className="">
                    <Row>
                        <div className="text-center display-1">
                            <h1>The Buddhist Meditation Association of Victoria</h1>
                        </div>
                    </Row>
                    <div>
                        <p className="lead">
                        The Buddhist Meditation Association of Victoria (BMAV) is an independent body managed by a committee of management appointed by its members. 
                        The Association was incorporated in 1994 under the Australian Government Incorporations Act 1981 as a Charitable and non-profitable religious organisation. 
                        The Association is also registered with the Australian Charities and Not-for-profits Commission (ACNC).
                        </p>
                    </div>
                    <br />
                    <div className="text-center display-1">
                        <h1>Purpose Of The Association</h1>
                    </div>

                    <ul className="">
                        <li><p className="lead">Establish and maintain a centre for meditation, provide necessary facilities for the practice of meditation and
                            encourage the practical observance of the Theravada Buddhism and sustain a way of life in keeping with the teachings of Lord Buddha.</p></li>
                        <li><p className="lead">Uplift moral, ethical and cultural values amongst Buddhist laity.</p></li>
                        <li><p className="lead">Train laity on the lines of the Theravada Buddhist way of life with the prime objective of helping them to
                            lead and sustain a righteous life.</p></li>
                        <li><p className="lead">Establish and maintain a library on Buddhist affairs and culture of Sri Lanka for the benefit of the
                            members as well as for the use of
                            the general public.</p></li>
                        <li><p className="lead">Collect and disseminate information on Theravada Buddhism and its culture.</p></li>
                        <li><p className="lead">Promote unity and mutual cooperation, peace and harmony among Buddhist laity.</p></li>
                        <li><p className="lead">Initiate action that promotes mutual understanding amongst the numerous religious denominations in Australia.</p></li>
                        <li><p className="lead">Organise and engage in cultural activities to promote, disseminate and foster the knowledge and value of the Sri Lankan cultural
                            traditions in Australia within the framework of multiculturalism.</p></li>
                        <li><p className="lead">Provide facilities to teach Sinhalese as a second language to the younger generation of the community and to inculcate and promote
                            in their minds an awareness of the value and significance of the Sinhalese language within the framework of multiculturalism in Australia.</p></li>
                        <li><p className="lead">Engage in activities which focus on and committed to the promotion of social welfare and well-being of elderly and general public
                            who are in need for help.</p></li>
                        <li><p className="lead">Establish and maintain facilities to provide counselling services using the teachings of Lord Buddha.</p></li>
                        <li><p className="lead">Teach younger generation of the Sri Lankan community living in Australia the value of Theravada Buddhism, unity, mutual cooperation,
                            peace and harmony among communities.</p></li>
                    </ul>

                </Container>
            </div>
        </div>
    )
}
export default Purpose;